import { createMakeStyles } from "tss-react";

export const theme = {
    "blue":         '#3AE',
    "darkBlue":     '#29D',
    "brightBlue":   '#4BF',
    "green":        '#3B9',
    "darkGreen":    '#2A8',
    "red":          "#E56",
    "darkRed":      "#D45",
    "normalFont":   22,
    "buttonShadow": '2px 3px 4px rgba(0,0,0,0.2)'
}

function useTheme() {
    return theme;
}

export const { makeStyles } = createMakeStyles({ useTheme });